// lib/startServiceConversation.js — CS-1 (بند ج2) · بديل كل رابط واتساب
// خارجي يخاطب عميلاً. لا wa.me ولا api.whatsapp.com: ينقل المستخدم إلى
// «الصندوق الموحّد» ويفتح «محادثة جديدة» بالرقم معبّأ ومصدر مسجَّل، فيمرّ
// الإرسال ببوابة wa_gate ويُسجَّل في المنصة برقم الشركة.
// PROD-FIX-2 (بند 4) — الوجهة الآن مركز التواصل ← الصندوق الموحّد مباشرة
// (تبويب «محادثات مباشرة» في واتساب أُزيل لأنه كان يكرّر نفس المكوّن).
export function startServiceConversation({ phone, source }) {
  const detail = { phone: String(phone || ""), source: String(source || "manual") };
  try {
    const u = new URL(window.location.href);
    u.searchParams.set("tab", "comms_hub");
    u.searchParams.set("sub", "unified");
    window.history.replaceState(null, "", u.toString());
  } catch (_e) { /* noop */ }
  window.dispatchEvent(new CustomEvent("tw-navigate", { detail: { tab: "comms_hub" } }));
  window.setTimeout(() => window.dispatchEvent(
    new CustomEvent("inbox-start-conversation", { detail })), 400);
}
